import { configureStore } from "@reduxjs/toolkit";
import userReducer from "./features/userSlice";
import authReducer from "./features/authSlice";
import productReducer from "./features/productSlice";
import categoriesReducer from "./features/categorySlice";
import ingrediantReducer from "./features/ingrediantSlice";
import drinkReducer from "./features/drinkSlice";
import typeReducer from "./features/typeSlice";
import extraReducer from "./features/extraSlice";
import desertReducer from "./features/desertSlice";
import historyReducer from "./features/historySlice";
import settingReducer from "./features/settingSlice";
import carouselReducer from "./features/carouselSlice";
import variationReducer from "./features/variationSlice";
import typeVariationReducer from "./features/typeVariationSlice";
import restaurantReducer from "./features/restaurantsSlice";
import couponsReducer from "./features/couponSlice";
import databaseReducer from "./features/backupSlice";
import currencyReducer from "./features/currencySlice";
import allergyReducer from "./features/allergySlice";
import mediaReducer from "./features/mediaSlice";

const store = configureStore({
  reducer: {
    auth: authReducer,
    restaurants: restaurantReducer,
    user: userReducer,
    categories: categoriesReducer,
    product: productReducer,
    settings: settingReducer,
    carousel: carouselReducer,
    ingrediant: ingrediantReducer,
    type: typeReducer,
    variation: variationReducer,
    typeVariation: typeVariationReducer,
    drink: drinkReducer,
    extra: extraReducer,
    desert: desertReducer,
    history: historyReducer,
    coupons: couponsReducer,
    databases: databaseReducer,
    currency: currencyReducer,
    allergy: allergyReducer,
    media: mediaReducer,
  },
});

export default store;
